import React, { useCallback, useState } from "react";

export const Context = React.createContext<HTMLDivElement | null>(null);

interface ModalDialogProviderProps {
    children?: React.ReactNode;
}

const ModalDialogProvider: React.FC<ModalDialogProviderProps> = ({ children }) => {
    const [context, setContext] = useState<HTMLDivElement | null>(null);

    const setModalRef = useCallback((node: HTMLDivElement | null) => {
        setContext(node);
    }, []);

    return (
        <>
            <Context.Provider value={context}>{children}</Context.Provider>
            <div ref={setModalRef} />
        </>
    );
};

export default ModalDialogProvider;
